"use client";

import { useQuery } from "@tanstack/react-query";

export type AppCountryRanking = {
  app_store_id: number;
  country_code: string;
  name: string | null;
  icon_url: string | null;
  ranking_position: number | null;
  previous_ranking_position: number | null;
  ranking_created_at: string;
  rating_count?: number | null;
  ratings_created_at?: string | null;
};

export function useAppCountryRankings(appId?: number, enabled = true) {
  return useQuery<{ items: AppCountryRanking[] }, Error>({
    queryKey: ["app-country-rankings", appId],
    enabled: enabled && typeof appId === "number",
    queryFn: async () => {
      const res = await fetch(`/api/app-country-rankings?appId=${appId}`);
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.error || `Failed: ${res.status}`);
      }
      return (await res.json()) as { items: AppCountryRanking[] };
    },
  });
}


